import React from 'react';

import Header from '../../components/user/header/Header.jsx';
import SubIntro from '../../components/user/sub_intro2/Intro.jsx';
import Content from '../../components/user/sub2_3/sub2_3_1/Content.jsx';

import Footer from '../../components/user/footer/Footer.jsx';

import s2_3_1_bg from '../../assets/images/s2_3_1_bg.png';

import '../../styles/user/common.css';
import '../../styles/user/default.css';
import '../../styles/user/fixed.css';
import '../../styles/user/font.css';
import '../../styles/user/footer.css';
import '../../styles/user/header.css';
import '../../styles/user/main.css';
import '../../styles/user/slick-theme.css';
import '../../styles/user/slick.css';
import '../../styles/user/sub.css';

export default function Sub2_3_1() {
  return (
    <>
      <Header />
      <SubIntro
        backgroundImage={s2_3_1_bg}
        mainTitle="프로페셔널 청소로봇"
        productName="CREAMBOT"
        productModel="C30"
        description="종합 청결, 흠집없는 공간을 위한 간편한 솔루션
"
        theme="dark"
      />
      <Content />
      <Footer />
    </>
  );
}
 